import '@lwc/synthetic-shadow';
import { createElement } from 'lwc';
import MyApp from 'my/app';

const app = createElement('my-app', { is: MyApp });
// eslint-disable-next-line @lwc/lwc/no-document-query
// document.querySelector('#main').appendChild(app);

const windowWidth = Math.max( window.screen.width, window.screen.height );
const windowHeight = Math.min( window.screen.width, window.screen.height);

console.log(windowWidth + ' :: '+windowHeight);

const displayView = (windowWidth >= 1000 && windowHeight >= 600);

if ( displayView ) {
  document.querySelector('#main').appendChild(app);
} else {
  document.querySelector('#responsiveDesignMain').setAttribute('style', 'visibility: visible ;');
}

//listen for window resize event
window.addEventListener('resize', function(event){
  var newWidth = window.innerWidth;
  var newHeight = window.innerHeight; 
  console.log(newWidth + ' :: '+newHeight);
 if (newWidth < 1261 || newHeight < 681) {
    document.querySelector('#main').setAttribute('style', 'visibility: hidden; display: none !important;');
    document.querySelector('#responsiveDesignMain').setAttribute('style', 'visibility: visible ;');
  } else {
    document.querySelector('#responsiveDesignMain').setAttribute('style', 'visibility: hidden ;');
    document.querySelector('#main').setAttribute('style', 'visibility: visible ;');
   }
});

window.addEventListener('click', function(event) {
    if(event && event.target && event.target.text === 'Privacy Policy') {
        window.open('https://www.ptc.com/en/documents/policies/privacy', '_blank');
    }
});